import * as React from 'react'

export const DownloadIcon3 = () => (
  <svg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14.4 11.6C14.4 11.904 14.232 12.168 13.976 12.304L7.656 15.856C7.528 15.952 7.368 16 7.2 16C7.032 16 6.872 15.952 6.744 15.856L0.424003 12.304C0.295747 12.2366 0.188413 12.1353 0.113661 12.0112C0.0389103 11.8871 -0.000399337 11.7449 3.05862e-06 11.6V4.4C3.05862e-06 4.096 0.168003 3.832 0.424003 3.696L6.744 0.144C6.872 0.048 7.032 0 7.2 0C7.368 0 7.528 0.048 7.656 0.144L13.976 3.696C14.232 3.832 14.4 4.096 14.4 4.4V11.6ZM7.2 1.72L2.432 4.4L7.2 7.08L11.968 4.4L7.2 1.72ZM1.6 11.128L6.4 13.832V8.464L1.6 5.768V11.128ZM12.8 11.128V5.768L8 8.464V13.832L12.8 11.128Z'
      fill='white'
    />
  </svg>
)
